module.exports = __webpack_public_path__ + "img/estado.7c1862bb.png";